import {PayloadAction} from '@reduxjs/toolkit';
import {ForkEffect, call, put, takeLatest} from 'redux-saga/effects';

import {login} from '../userSlice';
import {setAuthenticationToken, registerUser} from '../userApi';
import {Credentials} from '../userTypes';

type LoginPayload = {
  token: string;
  credentials: Credentials;
};

type LoginAction = PayloadAction<LoginPayload, 'user/requestLogin'>;

function requestLogin(payload: LoginPayload): LoginAction {
  return {
    type: 'user/requestLogin',
    payload,
  };
}

function* requestLoginSaga({payload}: LoginAction) {
  const {credentials, token} = payload;

  yield put(login(credentials));
  yield call(setAuthenticationToken, token);
  yield call(registerUser, credentials);
}

function* watchRequestLogin(): Generator<ForkEffect<void>, void, unknown> {
  yield takeLatest('user/requestLogin', requestLoginSaga);
}

export {requestLogin};

export default watchRequestLogin;
